import { useEffect, useState } from 'react';
import { Flex } from '../../../component-library';
import { useReceiveMessage } from '../../../context/messageContext';
import { Participant } from '../../../components';
import { useVideo } from '../../../context/videoContext';
import { calibrationConstants } from '../../../helpers/calibration-constants';
import LandoltC from '../../../components/VisualFieldForthValley/LandoltC';

const FamiliarisationPhase = () => {
  const { participants } = useVideo();
  const { blindSpotThumbnailWidthPx, blindSpotThumbnailHeightPx } = calibrationConstants;
  const messageFromOptician = useReceiveMessage();
  const [landoltCOpeningQuadrant, setLandoltCOpeningQuadrant] = useState(null);

  useEffect(() => {
    if (messageFromOptician.type === 'LandoltCOpeningUpdate') {
      setLandoltCOpeningQuadrant(messageFromOptician.content);
    }
  }, [messageFromOptician]);

  return (
    <Flex alignItems='center' justifyContent='center' height='100vh' width='100vw' backgroundColor='white'>
      <Flex justifyContent='center' alignItems='center' height='90%' width='75%' style={{ position: 'relative' }}>
        <LandoltC openingQuadrant={landoltCOpeningQuadrant} />
        <Flex
          width={blindSpotThumbnailWidthPx}
          height={blindSpotThumbnailHeightPx}
          style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        >
          {participants ? <Participant key={participants.sid} participant={participants} /> : null}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default FamiliarisationPhase;
